import { Typography, Stack } from '@mui/material';
import CustomizedCheckbox from '../../custom-checkbox/CustomizedCheckbox';
import { useCustomInputContext } from '../CustomInputContext';

const CustomInputUserAgreementEbook = () => {
  const { field, hasError, disabled } = useCustomInputContext();

  return (
    <Stack
      spacing={0.9}
      className={hasError ? 'UserAgreementError' : ''}
      direction="row"
      alignItems="flex-start"
      sx={{
        px: '16px',
        py: '18px',
        border: '1px solid #E5E8FF',
        borderRadius: '6px',
      }}
    >
      <CustomizedCheckbox field={field} disabled={disabled} />

      <Typography
        variant="body1"
        color="primaryDark.600"
        sx={{
          fontSize: '14px',
          // textTransform: 'uppercase',
          fontFamily: 'Gellix-Regular',
          lineHeight: '20px',
          letterSpacing: '0.05em',
          mt: '-2px',
        }}
      >
        By downloading this eBook, you agree to receive occasional emails from Spona with related
        insights. You can unsubscribe anytime. Read our{' '}
        <a
          href="/terms-of-service/privacy-policy"
          target="_blank"
          rel="noreferrer"
          style={{ color: '#6D51F6' }}
        >
          Privacy Policy.
        </a>
      </Typography>
    </Stack>
  );
};

export default CustomInputUserAgreementEbook;
